const n = {
  none: void 0,
  small: "d-py0",
  large: "d-py4"
}, d = {
  DROPDOWN_PADDING_CLASSES: n
};
export {
  n as DROPDOWN_PADDING_CLASSES,
  d as default
};
//# sourceMappingURL=dropdown-constants.js.map
